import clsx from "clsx";
import { useEffect, useState } from "react";

export const LoadingBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = () => {
      setIsVisible(true);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div
      className={clsx(
        "absolute inset-x-0 -bottom-px h-px origin-left bg-secondary opacity-0 transition-all delay-200 duration-1000 ease-in-out scale-x-0",
        isVisible && "opacity-100 scale-x-100",
      )}
    />
  );
};
